document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".variant-selector").forEach(function (button) {
    button.addEventListener("click", function () {
      let productId = this.getAttribute("data-product-id");
      let variantImage = this.getAttribute("data-variant-image");

      let productImage = document.querySelector(`#product-image-${productId}`);
      if (productImage) {
        productImage.src = variantImage;
      }
    });
  });
});
